import { palette } from '@/styles/figma-tokens';

interface HiddenIconProps {
  className?: string;
  /** Circle (ring) fill — defaults to mid gray. */
  color?: string;
  /** Diagonal strikethrough fill — defaults to light gray. */
  accentColor?: string;
}

export default function HiddenIcon({
  className,
  color = palette.grey['600'],
  accentColor = palette.grey['500'],
}: HiddenIconProps) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM15 24C19.9706 24 24 19.9706 24 15C24 10.0294 19.9706 6 15 6C10.0294 6 6 10.0294 6 15C6 19.9706 10.0294 24 15 24Z"
        fill={color}
      />
      <path
        d="M24.3979 2.46703C25.2631 1.60181 26.6659 1.60181 27.5311 2.46703C28.3963 3.33224 28.3963 4.73504 27.5311 5.60025L5.59855 27.5328C4.73333 28.3981 3.33054 28.3981 2.46532 27.5328C1.6001 26.6676 1.6001 25.2648 2.46532 24.3996L24.3979 2.46703Z"
        fill={accentColor}
      />
    </svg>
  );
}
